import { is, path, complement, pathEq } from 'ramda';
import { formatDate, validate } from 'lib/dateDisplay';

const isInUse = complement(pathEq(['hasEnded'], 'yes'));
const msg = id => ({ id });

export const formatStrength = d => d.strengthText || (d.strength && `${d.strength} ${d.strengthUnit || ''}`) || '';

export const formatDrugHeader = drug =>
  is(Object, drug) ? `${drug.name} (${drug.company}) ${drug.dosageForm} ${formatStrength(drug)}` : null;

export const formatMedDate = (drug, fm, accessor = msg) =>
  !isInUse(drug) && validate(path(['end'], drug))
    ? `${formatDate(path(['start'], drug))} - ${formatDate(path(['end'], drug))}`
    : fm(accessor('medication.dates.inUseFrom'), { startDate: formatDate(path(['start'], drug)) });
